import { axiosInstance } from '../axios/axiosConfig';

const controller = 'TrainerReservations';

export const getAllTrainerReservationsByPublicId = async (trainerPublicId) => {
    const response = await axiosInstance.get(`/${controller}/${trainerPublicId}`);
    return response.data;
};

export const ReserveSessions = async (data) => {
    const response = await axiosInstance.post(`/${controller}`, {
        trainerPublicId: data.trainerPublicId,
        times: data.times,
    });
    return response.data;
};

export const CancelReservations = async (trainerPublicId) => {
    const response = await axiosInstance.delete(`/${controller}/cancel-reservations/${trainerPublicId}`);
    return response.data;
};
